module.exports = fox._r("fonts/simplifica.svg", __webpack_public_path__ + "_/_/_/root/fonts/simplifica.svg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/simplifica.svg
// module id = 223
// module chunks = 4